import React from 'react';
import '../App.css';
import resume from '../Kellee-Martins-Resume.pdf'

const About = () => (
  <section id="about" className="About gradient">
    <div className="About-container">
      <h3>in a nutshell</h3>

      <div className="About-text">
        <h4>What I'm doing in my 9-5:</h4>
        <p>ReactJS, Redux, TypeScript, RxJS, ES6, SCSS, Jest, Cypress, Git, Jira</p>
      </div>

      <div className="About-text">
        <h4>What I've done before:</h4>
        <p>NodeJS, MongoDb, HTML5, CSS3, Firebase, D3, AngularJS, jQuery, PHP, WordPress, Photoshop, Shopify, Bitbucket</p>
      </div>

      <div className="About-text">
        <h4>What I'm doing in my spare time:</h4>
        <p>ReactNative, AWS, GraphQL, NextJS</p>
      </div>
      
      <div className="About-text">
        <a className="button" href={resume} download="">Download Resume</a>
      </div>
      
    </div>
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js